import styled, { css } from 'styled-components'
import { TEXT_CARD_DIMENSIONS } from 'types/imageCard'

export const HoverImage = styled.div`
  position: fixed;
  ${props =>
    props.coordinates
      ? css`
          position: fixed;
          top: ${props.coordinates.y + TEXT_CARD_DIMENSIONS.HEIGHT}px;
          left: ${props.coordinates.x + 50}px;
        `
      : css`
          position: absolute;
          top: ${TEXT_CARD_DIMENSIONS.HEIGHT}px;
          left: 20px;
        `}
  height: 311px;
  width: 223px;
  border-radius: 11px;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  // Must be 2 and not 1 because the tokens scroll container (library) uses a z-index of 1 (yes seriously)
  // Including that library was a mistake an a half I'll tell ya
  z-index: 2;
  box-shadow: 2px 2px 10px #000000;
  opacity: ${props => (props.containerHovered ? '1' : '0')};
`

export const TextContainer = styled.div`
  border: ${props => (props.error ? '#ff2020' : 'auto')};
  border-style: solid;
  border-width: ${props => (props.error ? '1px' : '0')};

  background-color: ${props => (props.highlight ? '#FFAA00' : 'auto')}

  overflow: visible;
  position: relative;
  max-height: ${TEXT_CARD_DIMENSIONS.HEIGHT}px;
  min-width: 202px;
`

export const CardTitle = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  opacity: ${props => props.opacity ?? 1};
`
